
const observerOptions ={
    root: null, //observar con respecto al viewport
    rootMargin: '0px', //sin margen xtra
    threshold: 0.35 //disparar cuando el 20% sea visible
};

export function fxContactanos(){
    const contactanosSection = document.querySelector('#contactanos');
    const formulario = document.querySelector('.contactanos__formulario');

    if(contactanosSection){
        const observerCallback = (entries, observer) =>{
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    formulario.classList.add('contactanos__formulario--visible');
                    observer.unobserve(entry.target);
                }
            });
        }

        const contactanosObserver = new IntersectionObserver(observerCallback, observerOptions);
        contactanosObserver.observe(contactanosSection);
    }
}

export function fxHero(){
    const heroSection = document.querySelector('#hero');
    const heroTitle = document.querySelector('.hero__contenido-title');
    const heroText = document.querySelector('.hero__contenido-text');

    if(heroSection && heroTitle && heroText){

        const observerCallback = (entries, observer) =>{
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    heroTitle.classList.add('hero__contenido-title--visible');
                    heroText.classList.add('hero__contenido-text--visible');
                    observer.unobserve(entry.target);
                }
            });
        }

        const heroObserver = new IntersectionObserver(observerCallback, observerOptions);
        heroObserver.observe(heroSection);
    }
}

export function fxNosotros(){
    const nosotrosSection = document.querySelector('#nosotros');
    const nosotrosImage = document.querySelector('.nosotros__imagen');
    const nosotrosCompany = document.querySelector('.nosotros__company');
    
    if(nosotrosSection && nosotrosCompany && nosotrosImage){
        const observerCallback = (entries, observer) =>{
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    nosotrosImage.classList.add('nosotros__imagen--visible');
                    nosotrosCompany.classList.add('nosotros__company--visible');
                    observer.unobserve(entry.target);
                }
            });
        }

        const nosotrosObserver = new IntersectionObserver(observerCallback, observerOptions);
        nosotrosObserver.observe(nosotrosSection);
    }
}